import TotalSellComponent from "components/Reports/TotalSellComponent";
import Table from "components/Table";

const Total = () => {
    return <TotalSellComponent type="buyByProducts"/>;
};

export default function BuyByProducts() {
    return (
        <div className="wrap-journal">
            <Table type="buyByProducts" sumAmountInfo={[
                {name:"buyQuantity",isCurrency:false},
                {name:"buyAmount",isCurrency:true},
                {name:"buyReturnsQuantity",isCurrency:false},
                {name:"buyReturnsAmount",isCurrency:true},
                {name:"buyDiscount",isCurrency:true},
                {name:"buyTax",isCurrency:true},
                ]} MidComponent={Total}/>
        </div>
    );
}
